






























































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
@Component
export default class MaterialModal extends Vue {
  @Prop()
  show!: boolean;
  @Prop()
  type!: string;

  handleOk() {
    this.$emit("ok");
  }
  handleCancel() {
    this.$emit("cancel");
  }
}
